import React, { useContext } from 'react';
import AccountPickerBar from './AccountPickerBar';
import ExternalLinks from '../shared/ExternalLinks';
import classNames from 'classnames';
import assetAccountContext from '../../context/assetAccountContext';
import { standardDateFormat } from '../../utils/dateFormatter';
import { formatCurrency } from '../../utils/numberFormatter';
import BackgroundBar from '../styled/BackgroundBar';
import styles from './BalanceBar.module.scss';

const BalanceBar: React.FC = () => {
  const { selectedAccount, retailEnabled } = useContext(assetAccountContext);

  if (
    selectedAccount === undefined ||
    selectedAccount.dailyReport.portfolioTotal === null
  ) {
    return null;
  }

  const {
    dailyReport: {
      asOfDate,
      portfolioTotal: { marketValue }
    }
  } = selectedAccount;

  const date = standardDateFormat(asOfDate);
  const accountBalance = formatCurrency(marketValue);

  return (
    <BackgroundBar
      className={classNames('beacon-on-dark', styles['balance-bar-container'])}
      contentClassName={styles['balance-bar-content']}>
      <div className={styles['account-balance']}>
        <AccountPickerBar />
        <div className={styles['balance']}>
          <div
            className={classNames(styles['as-of-date'], styles['description'])}>
            As of {date}
          </div>
          <div className={styles['balance-title']}>Account Balance</div>
          <div>{accountBalance}</div>
        </div>
      </div>
      <ExternalLinks
        linkClassName={styles['external-link']}
        retailEnabled={retailEnabled}
      />
    </BackgroundBar>
  );
};

export default BalanceBar;
